import {Component} from '@angular/core';
import {ListViewItem} from "@domain/common/list-view/list-view-item";
import {UserDto,StatutOubli} from "@domain/user/user-dto";
import {Router} from "@angular/router";

/**
 * Item de la liste des utilisateurs internes
 */
@Component({
	host: {'data-test-id': 'utilisateurs-internes-list-item'},
	selector: 'utilisateurs-internes-list-item',
	templateUrl: './utilisateurs-internes-list-item.component.html'
})
export class UtilisateursInternesListItemComponent extends ListViewItem<UserDto> {
	/**
	 * Constructeur
	 *
	 * @param router le routeur Angular
	 */
	constructor(
		private router: Router
	) {
		super();
	}

	//Expose l'énumération au template
	StatutOubli = StatutOubli;

	/**
	 * Fonction appelée au clic sur un utilisateur
	 */
	navigateTo(): void {
		//Navigation vers l'utilisateur
		this.router.navigate(['Admin/Entreprise/Utilisateurs/User',this.data.idUser]);
	}
}